import { defineMessages } from 'react-intl';

const trns = defineMessages({
  aboutUsTitle: {
    id: 'UHT66h',
    defaultMessage: 'Про портал LikiE'
  },
  aboutUsDescription1: {
    id: '9PczAV',
    defaultMessage:
      'LikiЄ – це ще й докладний довідник лікарських препаратів. Тут ви знайдете максимально повну інформацію про ліки та інші медичні товари, їх аналоги, особливості застосування. Це допоможе лікуватися грамотно та не купувати зайве.'
  },
  aboutUsDescription2: {
    id: 'WfKQK3',
    defaultMessage:
      'Залишайтеся з Likie! Оформлюйте підписку та будьте в курсі всіх найвигідніших пропозицій.'
  },
  aboutUsGoal: {
    id: 'oO95fJ',
    defaultMessage:
      'Наша мета - зекономити ваш час та гроші, і ось як ми це робимо:'
  },
  aboutUsGoal1: {
    id: 'o51UTF',
    defaultMessage:
      'ми зібрали на LikiЄ всі затребувані препарати на ринку України, а їх, на хвилинку, більше 30 тисяч;'
  },
  aboutUsGoal2: {
    id: 'zX7y3o',
    defaultMessage:
      'за допомогою складних алгоритмів розумного пошуку, ми миттєво аналізуємо всі існуючі пропозиції у сотнях аптек і пропонуємо вам перелік з найкращих варіантів, де можна забронювати товари, у зручній для вас локації і за вигідною ціною;'
  },
  aboutUsGoal3: {
    id: 'OogCDw',
    defaultMessage:
      'замовляючи товар через LikiЄ ви отримуєте не тільки знижку, а й якісний сервіс і швидке інформування.'
  }
});

export default trns;
